<template>
<div class="left_side">
  <div class="main">
    <ul v-if="list.length > 0">
      <li :class="[current == 'all' && 'active']" @click="handetabs('all')">
        <span>{{ $t('nav.cricket') }} ( {{ totalwidth }} )</span>
      </li>
      <li v-for="(item,id) in list" :key="id + 'life'" :class="[{'active': current == id } ,'havelist']" @click="handetabs(id)">
        <span>{{ item.name }}</span>
        <span style="font-weight: 550;margin-left:5px;">{{ item.arr.length }}</span>
      </li>
    </ul>
    <ul v-else>
      <li :class="[current == 'all' && 'active']">
        <span>{{ $t('nav.cricket') }} ( 0 )</span>
      </li>
      <li v-for="(item,id) in defaultData" :key="id + 'life'" :class="[{'active': current == id } ,'havelist']">
        <span>{{ $t(item.name) }}</span>
        <span style="font-weight: 550;margin-left:5px;">{{ item.arr.length }}</span>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
export default {
  props:{
    list:{
      type:Array,
      default:[]
    }
  },
  computed:{
    totalwidth(){
      let w = []
      if(this.list.length >0){
        this.list.map(item=>{
          w.push(item.arr.length)
        })
        return w.reduce((val,val2)=>{
          return val + val2
        })
      }
    }
  },
  data(){
    return{
      current:'all',
      defaultData:[
        { index:'002',name:'newHome.Cicket.Momentum',arr:[]},
        { index:'003',name:'newHome.Cicket.OneInternationals',arr:[]},
        { index:'004',name:'newHome.Cicket.ford',arr:[]},
        { index:'005',name:'newHome.Cicket.TwentyBash',arr:[]},
        { index:'006',name:'newHome.Cicket.Others',arr:[]},
      ]
    }
  },
  methods:{
    handetabs(id){
      this.current = id
      if(this.$route.query.id){
        this.current = 'all'
        this.$router.push({ path:'/home'})
      }
      this.$emit('hadleSearch',this.current)
    }
  },
}

</script>
<style lang="scss" scoped>
.left_side{
  width:260px;
  .main{
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
    ul{
      background-color: #37573f;
      box-shadow: 0px 0px 2px 0px 
		rgba(0, 0, 0, 0.1);
      padding-bottom:20px;
      -webkit-text-stroke: .3px;
      li{
        display:flex;
        align-items: center;
        padding:13px 18px;
        justify-content: space-between;
        font-family: Roboto-Black;
        font-size: 14px;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #fff;
        // border-bottom:1px solid #fff;
        cursor: pointer;
        &.active{ 
          font-weight: 550;
          border-bottom:1px solid #fff;
        }
      }
    }
  }
}

</style> 


// WEBPACK FOOTER //
// src/pages/build902/components/new-home/L-side/index.vue